import { Button } from '@retailer-platform/shared-components'
import React, { type FunctionComponent } from 'react'
import { PageHeader } from '@retailer-platform/shared-components'
import { Breadcrumb } from '@retailer-platform/shared-components'
import { useDomainMessage } from 'domains/collections/utils/domain/intl'
import { CollectionsBreadcrumbs } from 'domains/collections/components/breadcrumbs/CollectionsBreadcrumbs'
import { type CollectionsRoutingConfig } from 'domains/collections/types/collections.types'

interface Props {
  routingConfig: CollectionsRoutingConfig
  name: string
  goToEdit: () => void
  modifyActionsAllowed: boolean
  openDelete: () => void
  retailerId: string
  baseBreadcrumbs: React.ReactChild
}

export const CollectionsViewHeader: FunctionComponent<Props> = ({
  routingConfig,
  name,
  goToEdit,
  modifyActionsAllowed,
  openDelete,
  baseBreadcrumbs,
}) => {
  const editMessage = useDomainMessage('collectionsDomain.view.action.edit')
  const deleteMessage = useDomainMessage('collectionsDomain.view.action.delete')

  return (
    <PageHeader
      addBottomPadding
      title={
        <CollectionsBreadcrumbs routingConfig={routingConfig} baseBreadcrumbs={baseBreadcrumbs}>
          {name && <Breadcrumb>{name}</Breadcrumb>}
        </CollectionsBreadcrumbs>
      }
      actions={
        modifyActionsAllowed && (
          <React.Fragment>
            <Button variant="secondary" onClick={openDelete}>
              {deleteMessage}
            </Button>
            <Button onClick={goToEdit}>{editMessage}</Button>
          </React.Fragment>
        )
      }
    />
  )
}
